function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useMemo, useState } from 'react';
import { Box, Flex, Icon, icons } from '@tapresearch/ui/components';
import { useDisclosure } from '@tapresearch/ui/hooks';
import { useTapSurveyQuestionsList } from '../../../api';
import { FilterProvider, OpenFilterButton } from '../../common';
import { useGetFilterFromLocation, useUpdateLocationFromFilter, useCurrentUser } from '../../hook';
import useAsset from '../../hook/useAsset';
import { ResultsFilterBadges } from './ResultsFilterBadges';
import { ResultsFilterDrawer } from './ResultsFilterDrawer';
import { SurveyQuestionItemResults } from './SurveyQuestionItemResults';
export var SurveyResultsWrapper = function(param) {
    var tapSurveyIdentifier = param.tapSurveyIdentifier, countryId = param.countryId, languageId = param.languageId, questionsHash = param.questionsHash, campaignResultIdentifier = param.campaignResultIdentifier;
    var asset = useAsset();
    var _useCurrentUser = useCurrentUser(), currentUser = _useCurrentUser.user;
    var _useDisclosure = useDisclosure(), onOpenFilterDrawer = _useDisclosure.onOpen, onCloseFilterDrawer = _useDisclosure.onClose, isOpenFilterDrawer = _useDisclosure.isOpen;
    var defaultFilter = useGetFilterFromLocation({
        filter: {}
    });
    var _useState = _sliced_to_array(useState(defaultFilter), 2), resultsFilter = _useState[0], setResultsFilter = _useState[1];
    var updateFilter = function(filterValues) {
        setResultsFilter(_object_spread_props(_object_spread({}, resultsFilter), {
            filter: filterValues
        }));
    };
    var _useTapSurveyQuestionsList = useTapSurveyQuestionsList(tapSurveyIdentifier, campaignResultIdentifier), tmp = _useTapSurveyQuestionsList.data, tapQuestions = tmp === void 0 ? [] : tmp;
    useUpdateLocationFromFilter(resultsFilter);
    var _useMemo = _sliced_to_array(useMemo(function() {
        return [
            Object.entries(questionsHash).filter(function(param) {
                var _param = _sliced_to_array(param, 1), questionId = _param[0];
                return !questionId.startsWith('tq_');
            }).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), questionId = _param[0], question = _param[1];
                return _object_spread_props(_object_spread({}, acc), _define_property({}, questionId, question));
            }, {}),
            Object.entries(questionsHash).filter(function(param) {
                var _param = _sliced_to_array(param, 1), questionId = _param[0];
                return !!questionId.startsWith('tq_');
            }).filter(function(param) {
                var _param = _sliced_to_array(param, 2), question = _param[1];
                return ![
                    asset.constants.TAP_ANSWER_TYPE_RANKING,
                    asset.constants.TAP_ANSWER_TYPE_MESSAGE,
                    asset.constants.TAP_ANSWER_TYPE_FREE_TEXT
                ].includes(question.answer_type);
            }).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), questionId = _param[0], question = _param[1];
                return _object_spread_props(_object_spread({}, acc), _define_property({}, questionId, question));
            }, {})
        ];
    }, [
        asset,
        questionsHash
    ]), 2), demographicCompareQuestions = _useMemo[0], tapCompareQuestions = _useMemo[1];
    return /*#__PURE__*/ React.createElement(Box, {
        "data-testid": "survey-results-wrapper"
    }, /*#__PURE__*/ React.createElement(FilterProvider, {
        defaultFilterValues: defaultFilter['filter'],
        onFilterUpdated: updateFilter
    }, currentUser && /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(ResultsFilterBadges, {
        onTagClicked: onOpenFilterDrawer
    }), /*#__PURE__*/ React.createElement(Flex, null, /*#__PURE__*/ React.createElement(OpenFilterButton, {
        "data-testid": "survey-results-open-filters-button",
        onClick: onOpenFilterDrawer,
        omitFilters: [
            'page',
            'query',
            'sort_by',
            'status'
        ]
    }, /*#__PURE__*/ React.createElement(Icon, {
        mr: "2",
        icon: icons.fi.Filter
    }), " Filter"))), /*#__PURE__*/ React.createElement(Box, {
        mt: "5"
    }, tapQuestions.map(function(tapQuestion) {
        return /*#__PURE__*/ React.createElement(SurveyQuestionItemResults, {
            key: tapQuestion.id,
            tapQuestion: tapQuestion.attributes,
            countryId: countryId,
            languageId: languageId,
            filters: resultsFilter.filter,
            campaignResultIdentifier: campaignResultIdentifier,
            comparisonQuestions: [
                demographicCompareQuestions,
                tapCompareQuestions
            ]
        });
    })), currentUser && languageId && countryId && /*#__PURE__*/ React.createElement(ResultsFilterDrawer, {
        isOpen: isOpenFilterDrawer,
        onClose: onCloseFilterDrawer,
        countryId: countryId,
        languageId: languageId
    })));
};
